var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{staticClass:"group"},[_c('div',{staticClass:"faq-page"},[_c('h3',[_c('span',[_vm._v("Duplex.")]),_vm._v(" World-class performance on stable assets.")]),_c('faq-list',{attrs:{"faqs":_vm.faqs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }